// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessageBodySkeleton-moduleEmailProfileMessageBodySkeleton__iOeyJ";
var _2 = "EmailProfileMessageBodySkeleton-moduleaction0__Mst2g";
var _3 = "EmailProfileMessageBodySkeleton-moduleaction1__VYrcL";
var _4 = "EmailProfileMessageBodySkeleton-moduleaction2__VPNa0";
var _5 = "EmailProfileMessageBodySkeleton-moduleactions__snw5K";
var _6 = "EmailProfileMessageBodySkeleton-modulemessageContainer___Cfo6";
var _7 = "EmailProfileMessageBodySkeleton-modulemessageItem__xVOzZ";
var _8 = "EmailProfileMessageBodySkeleton-modulemessageItem0__L2NPT";
var _9 = "EmailProfileMessageBodySkeleton-modulemessageItem2__MX3ZG";
var _a = "EmailProfileMessageBodySkeleton-modulemessageItem3__rTLvq";
var _b = "EmailProfileMessageBodySkeleton-modulemessageItem4__QwKNf";
var _c = "EmailProfileMessageBodySkeleton-modulemessageItem5__EdVsR";
var _d = "EmailProfileMessageBodySkeleton-modulemessageItem6__zGWDd";
var _e = "EmailProfileMessageBodySkeleton-modulemessageItem7__lbQGQ";
export { _1 as "EmailProfileMessageBodySkeleton", _2 as "action0", _3 as "action1", _4 as "action2", _5 as "actions", _6 as "messageContainer", _7 as "messageItem", _8 as "messageItem0", _9 as "messageItem2", _a as "messageItem3", _b as "messageItem4", _c as "messageItem5", _d as "messageItem6", _e as "messageItem7" }
